import React, { PropsWithChildren, ReactNode } from "react";
import { ModalsKeys } from "global";
import { ModalsContainer } from "../Modals";
import { RenderWithCondition } from "../Conditional/RenderWithCondition";

interface Props {
  modals?: Partial<Record<ModalsKeys, ReactNode>>;
}

export const PageContainer = ({ modals, children }: PropsWithChildren<Props>) => (
  <>
    {children}

    <RenderWithCondition condition={Boolean(modals)} children={<ModalsContainer modalsWithKeys={modals!} />} />
  </>
);
